// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Urbanist:ital,wght@0,100..900;1,100..900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  font-family: "Urbanist", sans-serif;
}

/* 
scss
 */
/* 
Body Theme Color
 */
/* 
Dark Theme Colors
*/
/* 
Button Theme
*/
/* 
Max Dashboard scss
*/
/* 
Min Dashboard scss
*/
/* 
Max Dashboard scss
*/
.CustomFileUpload_dashboard__A3j5q {
  width: calc(100% - 320px);
  position: relative;
  left: 290px;
  padding: 35px 35px;
  border-radius: 0px;
  min-height: auto !important;
  background-color: #f5f6fa;
  height: calc(100vh - 160px);
  overflow-y: auto;
}

.CustomFileUpload_dashboardContain__NtdK3 {
  width: calc(100% - 320px);
  background-color: #f5f6fa;
  border-radius: 8px;
}

.CustomFileUpload_bodythemedark__OgYx- .CustomFileUpload_dashboardContain__NtdK3,
.CustomFileUpload_bodythemedark__OgYx- .CustomFileUpload_dashboard__A3j5q,
.CustomFileUpload_bodythemedark__OgYx- .CustomFileUpload_cont2__gjrQT {
  background-color: #0f1824;
}

.CustomFileUpload_top_header__kJy2q .CustomFileUpload_top_header_inner__mBjXm {
  background-color: transparent;
  height: auto;
  overflow-y: unset;
}

/* 
Min Dashboard scss
*/
.CustomFileUpload_cont2__gjrQT {
  width: calc(100% - 50px);
  left: 50px;
  position: relative;
  padding: 30px;
  border-radius: 8px;
  background: #f5f6fa;
  height: calc(100vh - 160px);
  min-height: auto !important;
  overflow-y: auto;
  /* 
  background-Color: \$dashboardbackgroundColor;
    padding-bottom: 8%;
  */
}

.CustomFileUpload_subLink__kM-XG svg {
  position: relative;
  top: -2px;
  left: -7px;
}

.CustomFileUpload_footer__yuC85 {
  height: 70px;
}

body {
  background-color: #fff;
}

/* 
THEME CHANGE
*/
.CustomFileUpload_bodythemelight__2gwNe {
  background-color: #fff;
  padding-top: 90px;
}

.CustomFileUpload_bodythemedark__OgYx- {
  background-color: #132337;
  padding-top: 90px;
}

/* 
Header Navbar Theme
*/
.CustomFileUpload_headerthemelight__7TCQ8 {
  background-color: #fff;
}

.CustomFileUpload_headerthemedark__iEG7- {
  background-color: #132337;
}

.CustomFileUpload_top_header__kJy2q {
  min-height: 90px;
  display: flex;
  align-items: center;
  position: fixed;
  width: 100%;
  z-index: 1;
  top: 0;
}

/* 
LEFT MENU THEME CHANGE
*/
.CustomFileUpload_menuthemelight__Sm2fa {
  background-color: #fff;
}

.CustomFileUpload_menuthemedark__9CdZZ {
  background-color: #132337;
}

/* 
LEFT MENU LINKS THEME CHANGE
*/
.CustomFileUpload_menulinklight__qqtl5 span {
  color: #666666 !important;
}

.CustomFileUpload_menulinklight__qqtl5 a {
  color: #cbcbcb !important;
}

.CustomFileUpload_menulinklight__qqtl5:hover span,
.CustomFileUpload_menulinklight__qqtl5:hover a {
  color: #fff !important;
}

.CustomFileUpload_menulinkdarkSelected__oupDT {
  background-color: #1c2e45;
  color: #3b82f6;
}

.CustomFileUpload_menuthemelight__Sm2fa .CustomFileUpload_menulinklightSelected__ZmblZ {
  /*background-color: \$lightthemecolor;*/
  color: #fff !important;
  background-color: #0f4d0f;
}

.CustomFileUpload_menuthemelight__Sm2fa .CustomFileUpload_menulinklightSelected__ZmblZ svg path {
  color: #fff !important;
  fill: #fff;
  stroke: #fff;
}

.CustomFileUpload_menulinkdark__ymbWB {
  color: #92afd3 !important;
}

.CustomFileUpload_menulinklight__qqtl5:hover {
  color: #fff !important;
  background-color: #0f4d0f;
}

.CustomFileUpload_menulinklight__qqtl5:hover svg path {
  color: #fff !important;
  fill: #fff;
  stroke: #fff;
}

.CustomFileUpload_menulinklight__qqtl5 .CustomFileUpload_sub_arrow__c72-- svg path {
  stroke: #cbcbcb !important;
}

.CustomFileUpload_menulinklight__qqtl5:hover .CustomFileUpload_sub_arrow__c72-- svg path {
  stroke: #fff !important;
}

.CustomFileUpload_menulinkdark__ymbWB .CustomFileUpload_sub_arrow__c72-- svg path {
  stroke: #92afd3 !important;
}

.CustomFileUpload_menulinkdark__ymbWB:hover .CustomFileUpload_sub_arrow__c72-- svg path {
  stroke: #fff !important;
}

.CustomFileUpload_menulinkdark__ymbWB:hover {
  background-color: #1c2e45;
  color: #fff;
}

/* 
BODY HEADERS
*/
.CustomFileUpload_headinglight__Mn5Nb {
  color: #60677e;
}

.CustomFileUpload_headingdark__TdnjU {
  color: #60677e;
}

/* 
SEARCH BOX THEME COLOR
*/
.CustomFileUpload_searchboxlight__lA\\+AW {
  background-color: #fff;
  border: none;
}

.CustomFileUpload_searchboxdark__rUf32 {
  background-color: #132337;
  color: #fff;
  border: none;
}

.CustomFileUpload_searchboxdark__rUf32::placeholder {
  color: #60677e;
}

/* 
CUSTOM TABLE THEME COLOR
*/
.CustomFileUpload_tableheadlight__VTIoB {
  background-color: #131f43;
  border-radius: 5px 5px 0px 0px;
}

.CustomFileUpload_tableheadlight__VTIoB th {
  color: #fff;
  background-color: #0f4d0f;
}

thead .CustomFileUpload_tableheadlight__VTIoB th:first-child,
thead .CustomFileUpload_tableheaddark__WPZk9 th:first-child {
  border-radius: 5px 0 0 0px;
}

thead .CustomFileUpload_tableheadlight__VTIoB th:last-child,
thead .CustomFileUpload_tableheaddark__WPZk9 th:last-child {
  border-radius: 0 5px 0px 0;
}

th:first-child {
  border-radius: 0px;
}

td:last-child {
  border-radius: 0px;
}

table.CustomFileUpload_table__aM\\+sM.CustomFileUpload_table-borderless__Hpec1 {
  border-collapse: separate !important;
  border-spacing: 0 0px !important;
}

.CustomFileUpload_tableheaddark__WPZk9 {
  background-color: #132337;
  color: #fff;
}

.CustomFileUpload_table-borderless__Hpec1 tr:nth-child(even) {
  background-color: #f9fafb;
}

.CustomFileUpload_table-borderless__Hpec1 .CustomFileUpload_left-section__ERIjV {
  padding-top: 10px;
}

.CustomFileUpload_tablebodylight__yFpPZ td,
.CustomFileUpload_tablebodydark__oGFjJ td {
  padding: 0.5rem 1rem !important;
  line-height: 30px;
}

.CustomFileUpload_tablebodylight__yFpPZ {
  background-color: #fff;
}
.CustomFileUpload_tablebodylight__yFpPZ:hover {
  background-color: #ddecf9;
  cursor: auto;
}

.CustomFileUpload_tablebodydark__oGFjJ {
  /* background-color: \$primarydark-color; */
  color: #60677e;
}
.CustomFileUpload_tablebodydark__oGFjJ:hover {
  background-color: rgba(33, 150, 243, 0.1);
  cursor: auto;
}

/* 
PAGINATION THEME COLOR
*/
.CustomFileUpload_paginationlight__3mheL {
  color: #60677e !important;
  font-size: 13px !important;
}

.CustomFileUpload_paginationdark__Nf5tG {
  color: #60677e !important;
  font-size: 13px !important;
}

/* 
SETTING FORM THEME COLOR
*/
.CustomFileUpload_formthemelight__oEEYP {
  background-color: #fff;
  color: #1d1d1d !important;
  box-shadow: 0px 10px 35px 0px rgba(56, 71, 109, 0.08);
}

.CustomFileUpload_formthemedark__3wMMI {
  background-color: #132337;
  color: #60677e !important;
  font-size: 14px;
}
.CustomFileUpload_formthemedark__3wMMI ::placeholder {
  color: #60677e;
}

/* 
VIEW FORM DETAILS BOX THEME COLOR
*/
.CustomFileUpload_viewformlight__IxEsG {
  background-color: #f3f6f9;
}

.CustomFileUpload_permissionboxlight__A\\+5o3 {
  background-color: #f8f9fa;
  border: 1px solid #dee2e6;
}

.CustomFileUpload_permissionboxdark__yBBdc {
  background-color: #0f1824;
  border: solid 1px #242434;
}

.CustomFileUpload_errormsgclr__dNhvp {
  color: red;
  font-size: 14px;
  margin-top: 5px;
}

/* 
Graph theme
*/
.CustomFileUpload_graphclrlight__DXnCP {
  background-color: #fff;
}

.CustomFileUpload_graphclrdark__e3X8W {
  background-color: #132337;
}

/* 
Counter theme
*/
#CustomFileUpload_card1bglight__p3Vtd {
  /* background: linear-gradient(90deg, rgba(181, 219, 177, 1) 13%, rgba(125, 178, 144, 1) 100%); */
  background-color: #fff;
}

#CustomFileUpload_card1bgdark__RccVF {
  background: #392f28;
}

#CustomFileUpload_card2bglight__USxdW {
  /* background: linear-gradient(90deg, rgba(243, 198, 165, 1) 0%, rgba(248, 163, 168, 1) 100%); */
  background-color: #fff;
}

#CustomFileUpload_card2bgdark__8D\\+0w {
  background: #1c3238;
}

#CustomFileUpload_card3bglight__9Ie-L {
  /* background: linear-gradient(90deg, rgba(213, 149, 211, 1) 0%, rgba(174, 132, 192, 1) 100%); */
  background-color: #fff;
}

#CustomFileUpload_card3bgdark__8xdtS {
  background: #3a2434;
}

#CustomFileUpload_card4bglight__RSZmv {
  /* background: linear-gradient(90deg, rgba(140, 212, 214, 1) 0%, rgba(150, 202, 247, 1) 100%); */
  background-color: #fff;
}

#CustomFileUpload_card4bgdark__ll8rf {
  background: #2f264f;
}

#CustomFileUpload_card1bgdark__RccVF a,
#CustomFileUpload_card1bgdark__RccVF p,
#CustomFileUpload_card2bgdark__8D\\+0w a,
#CustomFileUpload_card2bgdark__8D\\+0w p,
#CustomFileUpload_card3bgdark__8xdtS a,
#CustomFileUpload_card3bgdark__8xdtS p,
#CustomFileUpload_card4bgdark__ll8rf a,
#CustomFileUpload_card4bgdark__ll8rf p {
  color: #fff;
}

/* 
Action button theme
*/
.CustomFileUpload_actionbtnlight__FGxd1 {
  color: rgba(70, 71, 91, 0.8705882353);
}

.CustomFileUpload_actionbtnlight__FGxd1:hover {
  cursor: pointer;
}

.CustomFileUpload_actionbtndark__H1seI {
  color: #60677e;
}

/* 
profile dropdowntheme
*/
.CustomFileUpload_profiledropdownlight__WbVPp {
  background-color: #fff;
}

.CustomFileUpload_profiledropdowndark__Ml20C {
  background-color: #151521;
}

.CustomFileUpload_settingsection__yb3ld #CustomFileUpload_addform__2XHs5.CustomFileUpload_formthemedark__3wMMI .CustomFileUpload_savebtn__ZMQGQ {
  background-color: #3b82f6;
  color: #fff;
}

#CustomFileUpload_addform__2XHs5.CustomFileUpload_formthemedark__3wMMI .CustomFileUpload_savebtn__ZMQGQ {
  background-color: #3b82f6;
  color: #fff;
}

.CustomFileUpload_profile_conatiner__jMYS7 {
  border-radius: 5px !important;
}

.CustomFileUpload_bodythemedark__OgYx- .CustomFileUpload_ag-theme-alpine__r6m-C .CustomFileUpload_ag-row__qOw3o {
  background: #000 !important;
}

.CustomFileUpload_bodythemedark__OgYx- .CustomFileUpload_formbtn__zh5Mv {
  background-color: #3b82f6;
}

.CustomFileUpload_bodythemedark__OgYx- .CustomFileUpload_formbtn__zh5Mv:hover {
  background-color: #2563eb;
}

.CustomFileUpload_bodythemedark__OgYx- .CustomFileUpload_resetbtn__y1kyI {
  color: #fff;
  background-color: transparent;
  border: solid 1px #3b82f6;
}

.CustomFileUpload_bodythemedark__OgYx- .CustomFileUpload_resetbtn__y1kyI:hover {
  background-color: #3b82f6;
}

.CustomFileUpload_headingdark__TdnjU span {
  background-color: #132337;
}

.CustomFileUpload_resetbtn__y1kyI {
  font-size: 16px;
  font-weight: 600;
  border-radius: 5px;
  background-color: transparent;
  border: solid 1px #131f43;
  color: #131f43;
  min-width: 113px;
}

.CustomFileUpload_resetbtn__y1kyI:hover,
.CustomFileUpload_resetbtn__y1kyI:active,
.CustomFileUpload_resetbtn__y1kyI:focus {
  background-color: #131f43;
  color: #fff;
}

.CustomFileUpload_addBtn__C4h1d {
  min-width: 140px;
  height: 44px;
  color: #fff;
  background-color: #38a169;
  border: none;
  font-size: 16px;
  font-weight: 600;
}

.CustomFileUpload_addbtnlight__xYeiq {
  background-color: #38a169;
}

.CustomFileUpload_addbtndark__MeRsn {
  background-color: #3b82f6;
}

.CustomFileUpload_addbtndark__MeRsn:hover {
  background-color: #2563eb;
}

.CustomFileUpload_formthemedark__3wMMI label {
  color: #92afd3;
}

.CustomFileUpload_addBtn__C4h1d svg {
  margin-right: 10px;
  position: relative;
  top: 2px;
}

.CustomFileUpload_addBtn__C4h1d:hover {
  color: #fff;
  background-color: #38a169;
  border: none;
}

.CustomFileUpload_cust_addBtn__YT\\+wT.CustomFileUpload_addBtn__C4h1d svg {
  top: 2px;
}

.CustomFileUpload_deleteBtn__T26Lx {
  min-width: 130px;
  height: 50px;
  background-color: #f94747;
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  border: none;
}

.CustomFileUpload_deleteBtn__T26Lx {
  min-width: 130px;
  height: 50px;
  background-color: #f94747;
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  border: none;
}

.CustomFileUpload_deleteBtn__T26Lx:active,
.CustomFileUpload_deleteBtn__T26Lx:focus {
  background-color: #f94747 !important;
  color: #fff !important;
  box-shadow: none !important;
}

.CustomFileUpload_deleteBtn__T26Lx svg {
  margin-right: 10px;
  position: relative;
  top: -2px;
}

.CustomFileUpload_deleteBtn__T26Lx:hover,
.CustomFileUpload_deleteBtn__T26Lx:active,
.CustomFileUpload_deleteBtn__T26Lx:focus {
  background-color: #f94747;
  color: #fff;
  border: none;
}

.CustomFileUpload_confirmBtn__EAWmY {
  background-color: #131f43;
}

.CustomFileUpload_confirmBtn__EAWmY:hover,
.CustomFileUpload_confirmBtn__EAWmY:active,
.CustomFileUpload_confirmBtn__EAWmY:focus {
  background-color: #131f43;
}

.CustomFileUpload_confirmBtn__EAWmY svg {
  top: 0;
}

.CustomFileUpload_delPopContainer__Cdqlz .CustomFileUpload_modal-body__FCE8h {
  padding: 25px;
  text-align: center;
}

.CustomFileUpload_delPopContainer__Cdqlz .CustomFileUpload_delet_icon__yL4Cm {
  margin-bottom: 11px;
}

.CustomFileUpload_delPopContainer__Cdqlz p {
  color: #131f43;
  font-size: 14px;
  font-weight: 700;
}

.CustomFileUpload_arrowback__AFY42 svg {
  fill: #000;
}

.CustomFileUpload_bodythemedark__OgYx- .CustomFileUpload_arrowback__AFY42 {
  background-color: rgba(59, 130, 246, 0.2);
  color: #3b82f6;
}

.CustomFileUpload_bodythemedark__OgYx- .CustomFileUpload_arrowback__AFY42 svg {
  fill: #3b82f6;
}

.CustomFileUpload_bodythemedark__OgYx- .CustomFileUpload_drpdwn_btn__hw5u8 {
  background-color: #132337;
}

.CustomFileUpload_bodythemedark__OgYx- .CustomFileUpload_empname__QdOi2 {
  color: #92afd3 !important;
}

.CustomFileUpload_bodythemedark__OgYx- .CustomFileUpload_navitemli__OqcoP a {
  background-color: transparent;
  border: solid 1px #3b82f6;
  color: #fff;
}

.CustomFileUpload_bodythemedark__OgYx- .CustomFileUpload_tabnavli__dOKh3 a.CustomFileUpload_settingsgeneral__1\\+PCY,
.CustomFileUpload_bodythemedark__OgYx- .CustomFileUpload_tabnavli__dOKh3 a.CustomFileUpload_settingslinks__xXnqV:hover {
  background-color: #3b82f6;
  color: #fff;
}

.CustomFileUpload_bodythemedark__OgYx- .CustomFileUpload_tabnavli__dOKh3 a.CustomFileUpload_settingslinks__xXnqV {
  background-color: transparent;
  border: solid 1px #3b82f6;
  color: #fff;
}

.CustomFileUpload_headerthemedark__iEG7- .CustomFileUpload_dropdown_menu_contain__01hrw {
  background-color: #1c2e45;
  color: #fff;
}

.CustomFileUpload_headerthemedark__iEG7- .CustomFileUpload_dropdown_menu_contain__01hrw ul li a,
.CustomFileUpload_headerthemedark__iEG7- .CustomFileUpload_dropdown_menu_contain__01hrw .CustomFileUpload_dropdown_item__gQw5I,
.CustomFileUpload_headerthemedark__iEG7- .CustomFileUpload_dropdown_menu_contain__01hrw .CustomFileUpload_dropdown_item__gQw5I h5 {
  color: #fff;
}

.CustomFileUpload_headerthemedark__iEG7- .CustomFileUpload_dropdown_menu_contain__01hrw ul li a:hover,
.CustomFileUpload_headerthemedark__iEG7- .CustomFileUpload_dropdown_menu_contain__01hrw .CustomFileUpload_dropdown_item__gQw5I:hover {
  background-color: #132337;
  color: #fff;
}

.CustomFileUpload_dropdown_item__gQw5I:active {
  background-color: #f5f6fa;
}

.CustomFileUpload_profile_arrrow_dwn__d1-N\\+ {
  stroke: #132337;
}

.CustomFileUpload_headerthemedark__iEG7- .CustomFileUpload_profile_arrrow_dwn__d1-N\\+ {
  stroke: #fff;
}

.CustomFileUpload_dateinputbox1__\\+Xw3U input,
.CustomFileUpload_dateinputbox1__\\+Xw3U span {
  color: #fff !important;
}

/* LOGOUT MODAL */
@media only screen and (max-width: 1200px) {
  .CustomFileUpload_tableheadlight__VTIoB th {
    min-width: 100px;
  }
}
@media only screen and (max-width: 1024px) {
  .CustomFileUpload_dashboard__A3j5q {
    width: calc(100% - 50px) !important;
    left: 50px !important;
    padding: 10px 10px !important;
  }
  .CustomFileUpload_cont2__gjrQT {
    height: calc(100vh - 160px);
    overflow-y: auto;
  }
}
@media only screen and (max-width: 998px) {
  /* #dashboardcont2{
    height: auto !important;
  }*/
}
@media only screen and (min-width: 767px) {
  .CustomFileUpload_messageminwidth__dhX9z {
    white-space: normal;
    word-wrap: break-word;
    width: 37%;
  }
}
@media only screen and (max-width: 767px) {
  td {
    max-width: 700px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .CustomFileUpload_messageminwidth__dhX9z {
    white-space: nowrap;
    word-wrap: break-word;
  }
  .CustomFileUpload_sectionright__2IKpO {
    float: unset !important;
  }
  .CustomFileUpload_dashboard__A3j5q {
    padding: 10px 10px !important;
  }
}
@media only screen and (max-width: 600px) {
  .CustomFileUpload_cont2__gjrQT {
    width: calc(100% - 50px) !important;
    left: 50px !important;
    position: relative !important;
    padding: 10px !important;
    overflow-x: inherit !important;
  }
  .CustomFileUpload_bodythemelight__2gwNe,
  .CustomFileUpload_bodythemedark__OgYx- {
    padding-top: 83px;
  }
  .CustomFileUpload_top_header__kJy2q {
    min-height: 69px;
  }
}
@media (min-width: 576px) {
  .CustomFileUpload_exer_modal_contain__0SRa7 .CustomFileUpload_modal-dialog__bwGnn {
    max-width: 1055px;
  }
  .CustomFileUpload_delPopContainer__Cdqlz .CustomFileUpload_modal-dialog__bwGnn {
    max-width: 350px;
  }
}
.CustomFileUpload_upload_btn__6k0sh {
  display: inline-block;
  border: 1px solid #ced4da;
  color: #60677e;
  padding: 5px 10px;
  font-size: 14px;
  border-radius: 5px;
  cursor: pointer;
}

.CustomFileUpload_uploaded_imgsection__-Sgt0 {
  width: 100px;
  height: 150px;
}

#CustomFileUpload_uploaded_img__v2uMC {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.CustomFileUpload_imgcancel_btn__eh4bW {
  border: none;
  font-size: 14px;
  padding: 5px 30px;
  background-color: #e2e3e7;
  margin-top: 5px;
  border-radius: 5px;
}
.CustomFileUpload_imgcancel_btn__eh4bW:hover {
  background-color: #a9a9a9;
}

.CustomFileUpload_close_icon_main__ZDd2K {
  position: relative;
  margin-right: 1rem;
}

.CustomFileUpload_close_icon__M0Rfn {
  position: absolute;
  right: 0px;
  border-radius: 0px 5px 0px 0px;
  width: 20px;
  height: 20px;
  background-color: #ffffff;
  border: 1px solid #ced4da;
}

.CustomFileUpload_formthemelight__oEEYP {
  box-shadow: none;
}

.CustomFileUpload_formthemedark__3wMMI .CustomFileUpload_upload_btn__6k0sh {
  border: 1px solid #92afd3 !important;
}`, "",{"version":3,"sources":["webpack://./src/styles/Variables/Variables.scss","webpack://./src/components/CustomFileUpload/CustomFileUpload.module.scss"],"names":[],"mappings":"AAEA;EACE,mCAAA;ACAF;;ADGA;;EAAA;AAgDA;;EAAA;AAWA;;CAAA;AAKA;;CAAA;AAQA;;CAAA;AAQA;;CAAA;AAMA;;CAAA;AAIA;EACE,yBAhBe;EAiBf,kBAAA;EACA,WAhBc;EAiBd,kBAAA;EACA,kBAAA;EACA,2BAAA;EACA,yBAvFO;EAwFP,2BAAA;EACA,gBAAA;ACrEF;;ADuEA;EACE,yBAAA;EACA,yBA7FO;EA8FP,kBAAA;ACpEF;;ADsEA;;;EAGE,yBAjEmB;ACFrB;;ADqEA;EACE,6BAAA;EACA,YAAA;EACA,iBAAA;AClEF;;ADqEA;;CAAA;AAIA;EACE,wBAvCU;EAwCV,UAvCS;EAwCT,kBAAA;EACA,aA/CiB;EAgDjB,kBAAA;EACA,mBArHO;EAsHP,2BAAA;EACA,2BAAA;EACA,gBAAA;EACA;;;GAAA;AChEF;;ADsEA;EACE,kBAAA;EACA,SAAA;EACA,UAAA;ACnEF;;ADsEA;EACE,YAAA;ACnEF;;ADsEA;EACE,sBA9FY;AC2Bd;;ADsEA;;CAAA;AAGA;EACE,sBArGY;EAsGZ,iBAAA;ACnEF;;ADqEA;EACE,yBApHe;EAqHf,iBAAA;AClEF;;ADqEA;;CAAA;AAGA;EACE,sBAjHY;AC+Cd;;ADqEA;EACE,yBAhIe;AC8DjB;;ADoEA;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,WAAA;EACA,UAAA;EACA,MAAA;ACjEF;;ADoEA;;CAAA;AAGA;EACE,sBArIY;ACoEd;;ADmEA;EACE,yBAnJe;ACmFjB;;ADmEA;;CAAA;AAGA;EACE,yBAAA;AChEF;;ADmEA;EACE,yBAAA;AChEF;;ADmEA;;EAEE,sBAAA;AChEF;;ADmEA;EACE,yBArKqB;EAsKrB,cA9KiB;AC8GnB;;ADkEA;EACE,sCAAA;EACA,sBAAA;EACA,yBAAA;AC/DF;;ADiEA;EACE,sBAAA;EACA,UAAA;EACA,YAAA;AC9DF;;ADiEA;EACE,yBAAA;AC9DF;;ADiEA;EACE,sBAAA;EACA,yBAAA;AC9DF;;ADiEA;EACE,sBAAA;EACA,UAAA;EACA,YAAA;AC9DF;;ADiEA;EACE,0BAAA;AC9DF;;ADiEA;EACE,uBAAA;AC9DF;;ADiEA;EACE,0BAAA;AC9DF;;ADiEA;EACE,uBAAA;AC9DF;;ADiEA;EACE,yBAnNqB;EAoNrB,WA3MY;AC6Id;;ADiEA;;CAAA;AAGA;EACE,cA/Me;ACiJjB;;ADiEA;EACE,cAnNe;ACqJjB;;ADiEA;;CAAA;AAGA;EACE,sBA7NY;EA8NZ,YAAA;AC9DF;;ADiEA;EACE,yBA7Oe;EA8Of,WAnOY;EAoOZ,YAAA;AC9DF;;ADgEA;EACE,cApOe;ACuKjB;;ADgEA;;CAAA;AAGA;EACE,yBAzRc;EA0Rd,8BAAA;AC7DF;;AD+DA;EACE,WAlPY;EAmPZ,yBAAA;AC5DF;;AD8DA;;EAEE,0BAAA;AC3DF;;AD6DA;;EAEE,0BAAA;AC1DF;;AD4DA;EACE,kBAAA;ACzDF;;AD2DA;EACE,kBAAA;ACxDF;;AD0DA;EACE,oCAAA;EACA,gCAAA;ACvDF;;AD0DA;EACE,yBAjQkB;EAkQlB,WA1QY;ACmNd;;ADyDA;EACE,yBAAA;ACtDF;;ADwDA;EACE,iBAAA;ACrDF;;ADuDA;;EAEE,+BAAA;EACA,iBAAA;ACpDF;;ADsDA;EACE,sBAxRY;ACqOd;ADqDE;EACE,yBAAA;EACA,YAAA;ACnDJ;;ADsDA;EACE,0CAAA;EACA,cA9Re;AC2OjB;ADqDE;EACE,yCAAA;EACA,YAAA;ACnDJ;;ADuDA;;CAAA;AAGA;EACE,yBAAA;EACA,0BAAA;ACpDF;;ADsDA;EACE,yBAAA;EACA,0BAAA;ACnDF;;ADsDA;;CAAA;AAGA;EACE,sBAzTY;EA0TZ,yBAAA;EACA,qDAAA;ACnDF;;ADqDA;EACE,yBAtTkB;EAuTlB,yBAAA;EACA,eAAA;AClDF;ADoDE;EACE,cAhUa;AC8QjB;;ADsDA;;CAAA;AAGA;EACE,yBA9UgB;AC2RlB;;ADsDA;EACE,yBAAA;EACA,yBAAA;ACnDF;;ADqDA;EACE,yBA7VmB;EA8VnB,yBAAA;AClDF;;ADqDA;EACE,UAAA;EACA,eAAA;EACA,eAAA;AClDF;;ADqDA;;CAAA;AAGA;EACE,sBAjWY;AC+Sd;;ADqDA;EACE,yBA7VkB;AC2SpB;;ADqDA;;CAAA;AAGA;EACE,iGAAA;EACA,sBA7WY;AC2Td;;ADqDA;EACE,mBAAA;AClDF;;ADqDA;EACE,gGAAA;EACA,sBAtXY;ACoUd;;ADqDA;EACE,mBAAA;AClDF;;ADqDA;EACE,gGAAA;EACA,sBA/XY;AC6Ud;;ADqDA;EACE,mBAAA;AClDF;;ADqDA;EACE,gGAAA;EACA,sBAxYY;ACsVd;;ADqDA;EACE,mBAAA;AClDF;;ADqDA;;;;;;;;EAQE,WAvZY;ACqWd;;ADqDA;;CAAA;AAGA;EACE,qCAAA;AClDF;;ADoDA;EACE,eAAA;ACjDF;;ADmDA;EACE,cAjae;ACiXjB;;ADmDA;;CAAA;AAGA;EACE,sBAAA;AChDF;;ADmDA;EACE,yBAAA;AChDF;;ADmDA;EACE,yBAlciB;EAmcjB,WApbY;ACoYd;;ADkDA;EACE,yBAtciB;EAucjB,WAxbY;ACyYd;;ADkDA;EACE,6BAAA;AC/CF;;ADkDA;EACE,2BAAA;AC/CF;;ADkDA;EACE,yBAndiB;ACoanB;;ADkDA;EACE,yBAtduB;ACuazB;;ADkDA;EACE,WA5cY;EA6cZ,6BAAA;EACA,yBAAA;AC/CF;;ADkDA;EACE,yBAjeiB;ACkbnB;;ADkDA;EACE,yBAjee;ACkbjB;;ADkDA;EACE,eAAA;EACA,gBA5gBc;EA6gBd,kBAAA;EACA,6BAAA;EACA,yBAAA;EACA,cA1gBc;EA2gBd,gBAAA;AC/CF;;ADiDA;;;EAGE,yBAhhBc;EAihBd,WAteY;ACwbd;;ADiDA;EACE,gBAAA;EACA,YAAA;EACA,WA5eY;EA6eZ,yBAtgBY;EAugBZ,YAAA;EACA,eAAA;EACA,gBAjiBc;ACmfhB;;ADiDA;EACE,yBA7gBY;AC+dd;;ADgDA;EACE,yBAtgBiB;ACydnB;;AD+CA;EACE,yBAxgBuB;AC4dzB;;AD+CA;EACE,cA9gBgB;ACkelB;;AD+CA;EACE,kBAAA;EACA,kBAAA;EACA,QAAA;AC5CF;;AD+CA;EACE,WAxgBY;EAygBZ,yBAliBY;EAmiBZ,YAAA;AC5CF;;AD+CA;EACE,QAAA;AC5CF;;AD+CA;EACE,gBAAA;EACA,YAAA;EACA,yBAtiBU;EAuiBV,WArhBY;EAshBZ,eAAA;EACA,gBAxkBc;EAykBd,YAAA;AC5CF;;AD+CA;EACE,gBAAA;EACA,YAAA;EACA,yBAhjBU;EAijBV,WA/hBY;EAgiBZ,eAAA;EACA,gBAllBc;EAmlBd,YAAA;AC5CF;;AD+CA;;EAEE,oCAAA;EACA,sBAAA;EACA,2BAAA;AC5CF;;AD+CA;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;AC5CF;;AD+CA;;;EAGE,yBAvkBU;EAwkBV,WAtjBY;EAujBZ,YAAA;AC5CF;;AD+CA;EACE,yBAtmBc;AC0jBhB;;AD+CA;;;EAGE,yBA5mBc;ACgkBhB;;AD+CA;EACE,MAAA;AC5CF;;AD+CA;EACE,aAAA;EACA,kBAAA;AC5CF;;AD+CA;EACE,mBAAA;AC5CF;;AD+CA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;AC5CF;;AD+CA;EACE,UAAA;AC5CF;;AD+CA;EACE,yCAzmBa;EA0mBb,cA9mBiB;ACkkBnB;;AD+CA;EACE,aAlnBiB;ACskBnB;;AD+CA;EACE,yBAhnBe;ACokBjB;;AD+CA;EACE,yBAAA;AC5CF;;AD+CA;EACE,6BAAA;EACA,yBAAA;EACA,WA/mBY;ACmkBd;;AD+CA;;EAEE,yBAnoBiB;EAooBjB,WArnBY;ACykBd;;AD8CA;EACE,6BAAA;EACA,yBAAA;EACA,WA1nBY;AC+kBd;;AD8CA;EACE,yBAvoBqB;EAwoBrB,WA/nBY;AColBd;;AD8CA;;;EAGE,WAroBY;AC0lBd;;AD8CA;;EAEE,yBArpBe;EAspBf,WA3oBY;ACgmBd;;AD8CA;EACE,yBA3rBO;ACgpBT;;AD8CA;EACE,eA9pBe;ACmnBjB;;AD8CA;EACE,YAvpBY;AC4mBd;;AD8CA;;EAEE,sBAAA;AC3CF;;AD8CA,iBAAA;AAOA;EACE;IACE,gBAAA;ECjDF;AACF;ADmDA;EACE;IACE,mCAAA;IACA,qBAAA;IACA,6BAAA;ECjDF;EDmDA;IACE,2BAAA;IACA,gBAAA;ECjDF;AACF;ADmDA;EACE;;IAAA;AC/CF;ADmDA;EACE;IACE,mBAAA;IACA,qBAAA;IACA,UAAA;ECjDF;AACF;ADoDA;EACE;IACE,gBAAA;IACA,mBAAA;IACA,gBAAA;IACA,uBAAA;EClDF;EDoDA;IACE,mBAAA;IACA,qBAAA;EClDF;EDoDA;IACE,uBAAA;EClDF;EDoDA;IACE,6BAAA;EClDF;AACF;ADoDA;EAEE;IACE,mCAAA;IACA,qBAAA;IACA,6BAAA;IACA,wBAAA;IACA,8BAAA;ECnDF;EDqDA;;IAEE,iBAAA;ECnDF;EDqDA;IACE,gBAAA;ECnDF;AACF;ADsDA;EACE;IACE,iBAAA;ECpDF;EDsDA;IACE,gBAAA;ECpDF;AACF;AAnvBA;EACI,qBAAA;EACA,yBAAA;EACA,cAAA;EACA,iBAAA;EACA,eAAA;EACA,kBAAA;EACA,eAAA;AAqvBJ;;AAlvBA;EACI,YAAA;EACA,aAAA;AAqvBJ;;AAlvBA;EACI,WAAA;EACA,YAAA;EACA,iBAAA;AAqvBJ;;AAlvBA;EACI,YAAA;EACA,eAAA;EACA,iBAAA;EACA,yBAAA;EACA,eAAA;EACA,kBAAA;AAqvBJ;AAnvBK;EACG,yBAAA;AAqvBR;;AAjvBA;EACI,kBAAA;EACA,kBAAA;AAovBJ;;AAlvBA;EACI,kBAAA;EACA,UAAA;EACA,8BAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,yBAAA;AAqvBJ;;AAlvBA;EACI,gBAAA;AAqvBJ;;AAlvBA;EACI,oCAAA;AAqvBJ","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Urbanist:ital,wght@0,100..900;1,100..900&display=swap');\n\nbody {\n  font-family: 'Urbanist', sans-serif;\n}\n\n/* \nscss\n */\n$font-regular: 400;\n$font-medium: 500;\n$font-semiBold: 600;\n$font-bold: 700;\n$font-extraBold: 800;\n$font-black: 900;\n\n$mainBg: #f5f6fa;\n$primary-color: #131f43;\n$icon-bgcolor: #f6f6f6;\n$text-graycolor: #727272;\n$cardIcon1-bg: #f3f4f8;\n$cardIcon1-darkbg: #30231a;\n$cardIcon1-darkbg-icon: #9d785f;\n$cardIcon2-bg: #faf4fb;\n$cardIcon2-darkbg: #13252a;\n$cardIcon2-darkbg-icon: #3b606a;\n$cardIcon3-bg: #faf7f3;\n$cardIcon3-darkbg: #2c1a27;\n$cardIcon3-darkbg-icon: #6c4863;\n$cardIcon4-bg: #f5f9fc;\n$cardIcon4-darkbg: #241d3e;\n$cardIcon4-darkbg-icon: #5f538b;\n$cardIcon2-color: #ac44bb;\n$cardIcon3-color: #d69a5f;\n$cardIcon4-color: #176ca5;\n$green-color: #38a169;\n$darkGreen-color: #207a4a;\n$placeholder-color: #666666;\n$profile-dark-text: #181818;\n$heading: #0b0d0f;\n$light-gray: #999999;\n$menu_icon: #cbcbcb;\n$red-color: #f94747;\n$dark-active-blue: #3b82f6;\n$dark-light-blue: #92afd3;\n$addBtn-dark-blue: #3b82f6;\n$addBtn-dark-blue-hover: #2563eb;\n$backBtn-dark: #3b82f633;\n\n$darkTheme_blue: #132337;\n$darkTheme_darkBlue: #0f1824;\n$darkTheme_selectBlue: #1c2e45;\n$darkTheme_updateBtn: #0a2574;\n\n/* \nBody Theme Color\n */\n$lightthemecolor: #f3f6f9;\n$darkthemecolor: #151521;\n\n$white-color: #fff;\n$black-color: #1d1d1d;\n$fullBlack-color: #1d1d1d;\n$lightthemetext: #60677e;\n\n/* \nDark Theme Colors\n*/\n$primarydark-color: #132337;\n\n/* \nButton Theme\n*/\n$primary-btncolor: #131f43;\n$secondary-btncolor: rgba(37, 105, 109, 0.864);\n\n$tableheadlightbg: #e9eaf0;\n\n/* \nMax Dashboard scss\n*/\n$dashboardwidth: calc(100% - 320px);\n$dashboardposition: absolute;\n$dashboardleft: 290px;\n$dashboardpadding: 30px;\n\n/* \nMin Dashboard scss\n*/\n$dashwidth: calc(100% - 50px);\n$dashleft: 50px;\n\n/* \nMax Dashboard scss\n*/\n\n.dashboard {\n  width: $dashboardwidth;\n  position: relative;\n  left: $dashboardleft;\n  padding: 35px 35px;\n  border-radius: 0px;\n  min-height: auto !important;\n  background-color: $mainBg;\n  height: calc(100vh - 160px);\n  overflow-y: auto;\n}\n.dashboardContain {\n  width: calc(100% - 320px);\n  background-color: $mainBg;\n  border-radius: 8px;\n}\n.bodythemedark .dashboardContain,\n.bodythemedark .dashboard,\n.bodythemedark .cont2 {\n  background-color: $darkTheme_darkBlue;\n}\n.top_header .top_header_inner {\n  background-color: transparent;\n  height: auto;\n  overflow-y: unset;\n}\n\n/* \nMin Dashboard scss\n*/\n\n.cont2 {\n  width: $dashwidth;\n  left: $dashleft;\n  position: relative;\n  padding: $dashboardpadding;\n  border-radius: 8px;\n  background: $mainBg;\n  height: calc(100vh - 160px);\n  min-height: auto !important;\n  overflow-y: auto;\n  /* \nbackground-Color: $dashboardbackgroundColor;\n  padding-bottom: 8%;\n*/\n}\n\n.subLink svg {\n  position: relative;\n  top: -2px;\n  left: -7px;\n}\n\n.footer {\n  height: 70px;\n}\n\nbody {\n  background-color: $white-color;\n}\n\n/* \nTHEME CHANGE\n*/\n.bodythemelight {\n  background-color: $white-color;\n  padding-top: 90px;\n}\n.bodythemedark {\n  background-color: $darkTheme_blue;\n  padding-top: 90px;\n}\n\n/* \nHeader Navbar Theme\n*/\n.headerthemelight {\n  background-color: $white-color;\n}\n\n.headerthemedark {\n  background-color: $darkTheme_blue;\n}\n.top_header {\n  min-height: 90px;\n  display: flex;\n  align-items: center;\n  position: fixed;\n  width: 100%;\n  z-index: 1;\n  top: 0;\n}\n\n/* \nLEFT MENU THEME CHANGE\n*/\n.menuthemelight {\n  background-color: $white-color;\n}\n.menuthemedark {\n  background-color: $darkTheme_blue;\n}\n\n/* \nLEFT MENU LINKS THEME CHANGE\n*/\n.menulinklight span {\n  color: $placeholder-color !important;\n}\n\n.menulinklight a {\n  color: $menu_icon !important;\n}\n\n.menulinklight:hover span,\n.menulinklight:hover a {\n  color: $white-color !important;\n}\n\n.menulinkdarkSelected {\n  background-color: $darkTheme_selectBlue;\n  color: $dark-active-blue;\n}\n.menuthemelight .menulinklightSelected {\n  /*background-color: $lightthemecolor;*/\n  color: $white-color !important;\n  background-color: #0f4d0f;\n}\n.menuthemelight .menulinklightSelected svg path {\n  color: $white-color !important;\n  fill: #fff;\n  stroke: #fff;\n}\n\n.menulinkdark {\n  color: $dark-light-blue !important;\n}\n\n.menulinklight:hover {\n  color: $white-color !important;\n  background-color: #0f4d0f;\n}\n\n.menulinklight:hover svg path {\n  color: $white-color !important;\n  fill: #fff;\n  stroke: #fff;\n}\n\n.menulinklight .sub_arrow svg path {\n  stroke: $menu_icon !important;\n}\n\n.menulinklight:hover .sub_arrow svg path {\n  stroke: $white-color !important;\n}\n\n.menulinkdark .sub_arrow svg path {\n  stroke: $dark-light-blue !important;\n}\n\n.menulinkdark:hover .sub_arrow svg path {\n  stroke: $white-color !important;\n}\n\n.menulinkdark:hover {\n  background-color: $darkTheme_selectBlue;\n  color: $white-color;\n}\n\n/* \nBODY HEADERS\n*/\n.headinglight {\n  color: $lightthemetext;\n}\n\n.headingdark {\n  color: $lightthemetext;\n}\n\n/* \nSEARCH BOX THEME COLOR\n*/\n.searchboxlight {\n  background-color: $white-color;\n  border: none;\n}\n\n.searchboxdark {\n  background-color: $darkTheme_blue;\n  color: $white-color;\n  border: none;\n}\n.searchboxdark::placeholder {\n  color: $lightthemetext;\n}\n\n/* \nCUSTOM TABLE THEME COLOR\n*/\n.tableheadlight {\n  background-color: $primary-color;\n  border-radius: 5px 5px 0px 0px;\n}\n.tableheadlight th {\n  color: $white-color;\n  background-color: #0f4d0f;\n}\nthead .tableheadlight th:first-child,\nthead .tableheaddark th:first-child {\n  border-radius: 5px 0 0 0px;\n}\nthead .tableheadlight th:last-child,\nthead .tableheaddark th:last-child {\n  border-radius: 0 5px 0px 0;\n}\nth:first-child {\n  border-radius: 0px;\n}\ntd:last-child {\n  border-radius: 0px;\n}\ntable.table.table-borderless {\n  border-collapse: separate !important;\n  border-spacing: 0 0px !important;\n}\n\n.tableheaddark {\n  background-color: $primarydark-color;\n  color: $white-color;\n}\n.table-borderless tr:nth-child(even) {\n  background-color: #f9fafb;\n}\n.table-borderless .left-section {\n  padding-top: 10px;\n}\n.tablebodylight td,\n.tablebodydark td {\n  padding: 0.5rem 1rem !important;\n  line-height: 30px;\n}\n.tablebodylight {\n  background-color: $white-color;\n\n  &:hover {\n    background-color: #ddecf9;\n    cursor: auto;\n  }\n}\n.tablebodydark {\n  /* background-color: $primarydark-color; */\n  color: $lightthemetext;\n\n  &:hover {\n    background-color: rgba(33, 150, 243, 0.1);\n    cursor: auto;\n  }\n}\n\n/* \nPAGINATION THEME COLOR\n*/\n.paginationlight {\n  color: $lightthemetext !important;\n  font-size: 13px !important;\n}\n.paginationdark {\n  color: $lightthemetext !important;\n  font-size: 13px !important;\n}\n\n/* \nSETTING FORM THEME COLOR\n*/\n.formthemelight {\n  background-color: $white-color;\n  color: $black-color !important;\n  box-shadow: 0px 10px 35px 0px rgb(56 71 109 / 8%);\n}\n.formthemedark {\n  background-color: $primarydark-color;\n  color: $lightthemetext !important;\n  font-size: 14px;\n\n  ::placeholder {\n    color: $lightthemetext;\n  }\n}\n\n/* \nVIEW FORM DETAILS BOX THEME COLOR\n*/\n.viewformlight {\n  background-color: $lightthemecolor;\n}\n\n.permissionboxlight {\n  background-color: #f8f9fa;\n  border: 1px solid #dee2e6;\n}\n.permissionboxdark {\n  background-color: $darkTheme_darkBlue;\n  border: solid 1px #242434;\n}\n\n.errormsgclr {\n  color: red;\n  font-size: 14px;\n  margin-top: 5px;\n}\n\n/* \nGraph theme\n*/\n.graphclrlight {\n  background-color: $white-color;\n}\n\n.graphclrdark {\n  background-color: $primarydark-color;\n}\n\n/* \nCounter theme\n*/\n#card1bglight {\n  /* background: linear-gradient(90deg, rgba(181, 219, 177, 1) 13%, rgba(125, 178, 144, 1) 100%); */\n  background-color: $white-color;\n}\n\n#card1bgdark {\n  background: #392f28;\n}\n\n#card2bglight {\n  /* background: linear-gradient(90deg, rgba(243, 198, 165, 1) 0%, rgba(248, 163, 168, 1) 100%); */\n  background-color: $white-color;\n}\n\n#card2bgdark {\n  background: #1c3238;\n}\n\n#card3bglight {\n  /* background: linear-gradient(90deg, rgba(213, 149, 211, 1) 0%, rgba(174, 132, 192, 1) 100%); */\n  background-color: $white-color;\n}\n\n#card3bgdark {\n  background: #3a2434;\n}\n\n#card4bglight {\n  /* background: linear-gradient(90deg, rgba(140, 212, 214, 1) 0%, rgba(150, 202, 247, 1) 100%); */\n  background-color: $white-color;\n}\n\n#card4bgdark {\n  background: #2f264f;\n}\n\n#card1bgdark a,\n#card1bgdark p,\n#card2bgdark a,\n#card2bgdark p,\n#card3bgdark a,\n#card3bgdark p,\n#card4bgdark a,\n#card4bgdark p {\n  color: $white-color;\n}\n\n/* \nAction button theme\n*/\n.actionbtnlight {\n  color: #46475bde;\n}\n.actionbtnlight:hover {\n  cursor: pointer;\n}\n.actionbtndark {\n  color: $lightthemetext;\n}\n\n/* \nprofile dropdowntheme\n*/\n.profiledropdownlight {\n  background-color: #fff;\n}\n\n.profiledropdowndark {\n  background-color: #151521;\n}\n\n.settingsection #addform.formthemedark .savebtn {\n  background-color: $addBtn-dark-blue;\n  color: $white-color;\n}\n#addform.formthemedark .savebtn {\n  background-color: $addBtn-dark-blue;\n  color: $white-color;\n}\n\n.profile_conatiner {\n  border-radius: 5px !important;\n}\n\n.bodythemedark .ag-theme-alpine .ag-row {\n  background: #000 !important;\n}\n\n.bodythemedark .formbtn {\n  background-color: $addBtn-dark-blue;\n}\n\n.bodythemedark .formbtn:hover {\n  background-color: $addBtn-dark-blue-hover;\n}\n\n.bodythemedark .resetbtn {\n  color: $white-color;\n  background-color: transparent;\n  border: solid 1px $addBtn-dark-blue;\n}\n\n.bodythemedark .resetbtn:hover {\n  background-color: $addBtn-dark-blue;\n}\n\n.headingdark span {\n  background-color: $darkTheme_blue;\n}\n\n.resetbtn {\n  font-size: 16px;\n  font-weight: $font-semiBold;\n  border-radius: 5px;\n  background-color: transparent;\n  border: solid 1px $primary-color;\n  color: $primary-color;\n  min-width: 113px;\n}\n.resetbtn:hover,\n.resetbtn:active,\n.resetbtn:focus {\n  background-color: $primary-color;\n  color: $white-color;\n}\n\n.addBtn {\n  min-width: 140px;\n  height: 44px;\n  color: $white-color;\n  background-color: $green-color;\n  border: none;\n  font-size: 16px;\n  font-weight: $font-semiBold;\n}\n\n.addbtnlight {\n  background-color: $green-color;\n}\n.addbtndark {\n  background-color: $addBtn-dark-blue;\n}\n.addbtndark:hover {\n  background-color: $addBtn-dark-blue-hover;\n}\n\n.formthemedark label {\n  color: $dark-light-blue;\n}\n\n.addBtn svg {\n  margin-right: 10px;\n  position: relative;\n  top: 2px;\n}\n\n.addBtn:hover {\n  color: $white-color;\n  background-color: $green-color;\n  border: none;\n}\n\n.cust_addBtn.addBtn svg {\n  top: 2px;\n}\n\n.deleteBtn {\n  min-width: 130px;\n  height: 50px;\n  background-color: $red-color;\n  color: $white-color;\n  font-size: 16px;\n  font-weight: $font-semiBold;\n  border: none;\n}\n\n.deleteBtn {\n  min-width: 130px;\n  height: 50px;\n  background-color: $red-color;\n  color: $white-color;\n  font-size: 16px;\n  font-weight: $font-semiBold;\n  border: none;\n}\n\n.deleteBtn:active,\n.deleteBtn:focus {\n  background-color: $red-color !important;\n  color: $white-color !important;\n  box-shadow: none !important;\n}\n\n.deleteBtn svg {\n  margin-right: 10px;\n  position: relative;\n  top: -2px;\n}\n\n.deleteBtn:hover,\n.deleteBtn:active,\n.deleteBtn:focus {\n  background-color: $red-color;\n  color: $white-color;\n  border: none;\n}\n\n.confirmBtn {\n  background-color: $primary-color;\n}\n\n.confirmBtn:hover,\n.confirmBtn:active,\n.confirmBtn:focus {\n  background-color: $primary-color;\n}\n\n.confirmBtn svg {\n  top: 0;\n}\n\n.delPopContainer .modal-body {\n  padding: 25px;\n  text-align: center;\n}\n\n.delPopContainer .delet_icon {\n  margin-bottom: 11px;\n}\n\n.delPopContainer p {\n  color: #131f43;\n  font-size: 14px;\n  font-weight: 700;\n}\n\n.arrowback svg {\n  fill: #000;\n}\n\n.bodythemedark .arrowback {\n  background-color: $backBtn-dark;\n  color: $dark-active-blue;\n}\n\n.bodythemedark .arrowback svg {\n  fill: $dark-active-blue;\n}\n\n.bodythemedark .drpdwn_btn {\n  background-color: $darkTheme_blue;\n}\n\n.bodythemedark .empname {\n  color: $dark-light-blue !important;\n}\n\n.bodythemedark .navitemli a {\n  background-color: transparent;\n  border: solid 1px $addBtn-dark-blue;\n  color: $white-color;\n}\n\n.bodythemedark .tabnavli a.settingsgeneral,\n.bodythemedark .tabnavli a.settingslinks:hover {\n  background-color: $addBtn-dark-blue;\n  color: $white-color;\n}\n.bodythemedark .tabnavli a.settingslinks {\n  background-color: transparent;\n  border: solid 1px $addBtn-dark-blue;\n  color: $white-color;\n}\n\n.headerthemedark .dropdown_menu_contain {\n  background-color: $darkTheme_selectBlue;\n  color: $white-color;\n}\n\n.headerthemedark .dropdown_menu_contain ul li a,\n.headerthemedark .dropdown_menu_contain .dropdown_item,\n.headerthemedark .dropdown_menu_contain .dropdown_item h5 {\n  color: $white-color;\n}\n\n.headerthemedark .dropdown_menu_contain ul li a:hover,\n.headerthemedark .dropdown_menu_contain .dropdown_item:hover {\n  background-color: $darkTheme_blue;\n  color: $white-color;\n}\n\n.dropdown_item:active {\n  background-color: $mainBg;\n}\n\n.profile_arrrow_dwn {\n  stroke: $darkTheme_blue;\n}\n\n.headerthemedark .profile_arrrow_dwn {\n  stroke: $white-color;\n}\n\n.dateinputbox1 input,\n.dateinputbox1 span {\n  color: $white-color !important;\n}\n\n/* LOGOUT MODAL */\n.modalStyleLight {\n}\n\n.modalStyleDark {\n}\n\n@media only screen and (max-width: 1200px) {\n  .tableheadlight th {\n    min-width: 100px;\n  }\n}\n@media only screen and (max-width: 1024px) {\n  .dashboard {\n    width: calc(100% - 50px) !important;\n    left: 50px !important;\n    padding: 10px 10px !important;\n  }\n  .cont2 {\n    height: calc(100vh - 160px);\n    overflow-y: auto;\n  }\n}\n@media only screen and (max-width: 998px) {\n  /* #dashboardcont2{\n    height: auto !important;\n  }*/\n}\n@media only screen and (min-width: 767px) {\n  .messageminwidth {\n    white-space: normal;\n    word-wrap: break-word;\n    width: 37%;\n  }\n}\n\n@media only screen and (max-width: 767px) {\n  td {\n    max-width: 700px;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n  .messageminwidth {\n    white-space: nowrap;\n    word-wrap: break-word;\n  }\n  .sectionright {\n    float: unset !important;\n  }\n  .dashboard {\n    padding: 10px 10px !important;\n  }\n}\n@media only screen and (max-width: 600px) {\n \n  .cont2 {\n    width: $dashwidth !important;\n    left: $dashleft !important;\n    position: relative !important;\n    padding: 10px !important;\n    overflow-x: inherit !important;\n  }\n  .bodythemelight,\n  .bodythemedark {\n    padding-top: 83px;\n  }\n  .top_header {\n    min-height: 69px;\n  }\n}\n\n@media (min-width: 576px) {\n  .exer_modal_contain .modal-dialog {\n    max-width: 1055px;\n  }\n  .delPopContainer .modal-dialog {\n    max-width: 350px;\n  }\n}\n","@import \"/src/styles/Variables/Variables.scss\";\n\n.upload_btn{\n    display: inline-block;\n    border: 1px solid #ced4da;\n    color: #60677e;\n    padding: 5px 10px;\n    font-size: 14px;\n    border-radius: 5px;\n    cursor: pointer;\n  }\n\n.uploaded_imgsection{\n    width: 100px;\n    height: 150px;\n}\n\n#uploaded_img{\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n}\n\n.imgcancel_btn{\n    border: none;\n    font-size: 14px;\n    padding: 5px 30px;\n    background-color: #e2e3e7;\n    margin-top: 5px;\n    border-radius: 5px;\n\n     &:hover{\n        background-color: #a9a9a9;\n     }\n}\n\n.close_icon_main{\n    position: relative;\n    margin-right: 1rem;\n}\n.close_icon{\n    position: absolute;\n    right: 0px;\n    border-radius: 0px 5px 0px 0px;\n    width: 20px;\n    height: 20px;\n    background-color: #ffffff;\n    border: 1px solid #ced4da; \n}\n\n.formthemelight {\n    box-shadow: none; \n}\n\n.formthemedark .upload_btn{\n    border: 1px solid $dark-light-blue !important;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dashboard": `CustomFileUpload_dashboard__A3j5q`,
	"dashboardContain": `CustomFileUpload_dashboardContain__NtdK3`,
	"bodythemedark": `CustomFileUpload_bodythemedark__OgYx-`,
	"cont2": `CustomFileUpload_cont2__gjrQT`,
	"top_header": `CustomFileUpload_top_header__kJy2q`,
	"top_header_inner": `CustomFileUpload_top_header_inner__mBjXm`,
	"subLink": `CustomFileUpload_subLink__kM-XG`,
	"footer": `CustomFileUpload_footer__yuC85`,
	"bodythemelight": `CustomFileUpload_bodythemelight__2gwNe`,
	"headerthemelight": `CustomFileUpload_headerthemelight__7TCQ8`,
	"headerthemedark": `CustomFileUpload_headerthemedark__iEG7-`,
	"menuthemelight": `CustomFileUpload_menuthemelight__Sm2fa`,
	"menuthemedark": `CustomFileUpload_menuthemedark__9CdZZ`,
	"menulinklight": `CustomFileUpload_menulinklight__qqtl5`,
	"menulinkdarkSelected": `CustomFileUpload_menulinkdarkSelected__oupDT`,
	"menulinklightSelected": `CustomFileUpload_menulinklightSelected__ZmblZ`,
	"menulinkdark": `CustomFileUpload_menulinkdark__ymbWB`,
	"sub_arrow": `CustomFileUpload_sub_arrow__c72--`,
	"headinglight": `CustomFileUpload_headinglight__Mn5Nb`,
	"headingdark": `CustomFileUpload_headingdark__TdnjU`,
	"searchboxlight": `CustomFileUpload_searchboxlight__lA+AW`,
	"searchboxdark": `CustomFileUpload_searchboxdark__rUf32`,
	"tableheadlight": `CustomFileUpload_tableheadlight__VTIoB`,
	"tableheaddark": `CustomFileUpload_tableheaddark__WPZk9`,
	"table": `CustomFileUpload_table__aM+sM`,
	"table-borderless": `CustomFileUpload_table-borderless__Hpec1`,
	"left-section": `CustomFileUpload_left-section__ERIjV`,
	"tablebodylight": `CustomFileUpload_tablebodylight__yFpPZ`,
	"tablebodydark": `CustomFileUpload_tablebodydark__oGFjJ`,
	"paginationlight": `CustomFileUpload_paginationlight__3mheL`,
	"paginationdark": `CustomFileUpload_paginationdark__Nf5tG`,
	"formthemelight": `CustomFileUpload_formthemelight__oEEYP`,
	"formthemedark": `CustomFileUpload_formthemedark__3wMMI`,
	"viewformlight": `CustomFileUpload_viewformlight__IxEsG`,
	"permissionboxlight": `CustomFileUpload_permissionboxlight__A+5o3`,
	"permissionboxdark": `CustomFileUpload_permissionboxdark__yBBdc`,
	"errormsgclr": `CustomFileUpload_errormsgclr__dNhvp`,
	"graphclrlight": `CustomFileUpload_graphclrlight__DXnCP`,
	"graphclrdark": `CustomFileUpload_graphclrdark__e3X8W`,
	"card1bglight": `CustomFileUpload_card1bglight__p3Vtd`,
	"card1bgdark": `CustomFileUpload_card1bgdark__RccVF`,
	"card2bglight": `CustomFileUpload_card2bglight__USxdW`,
	"card2bgdark": `CustomFileUpload_card2bgdark__8D+0w`,
	"card3bglight": `CustomFileUpload_card3bglight__9Ie-L`,
	"card3bgdark": `CustomFileUpload_card3bgdark__8xdtS`,
	"card4bglight": `CustomFileUpload_card4bglight__RSZmv`,
	"card4bgdark": `CustomFileUpload_card4bgdark__ll8rf`,
	"actionbtnlight": `CustomFileUpload_actionbtnlight__FGxd1`,
	"actionbtndark": `CustomFileUpload_actionbtndark__H1seI`,
	"profiledropdownlight": `CustomFileUpload_profiledropdownlight__WbVPp`,
	"profiledropdowndark": `CustomFileUpload_profiledropdowndark__Ml20C`,
	"settingsection": `CustomFileUpload_settingsection__yb3ld`,
	"addform": `CustomFileUpload_addform__2XHs5`,
	"savebtn": `CustomFileUpload_savebtn__ZMQGQ`,
	"profile_conatiner": `CustomFileUpload_profile_conatiner__jMYS7`,
	"ag-theme-alpine": `CustomFileUpload_ag-theme-alpine__r6m-C`,
	"ag-row": `CustomFileUpload_ag-row__qOw3o`,
	"formbtn": `CustomFileUpload_formbtn__zh5Mv`,
	"resetbtn": `CustomFileUpload_resetbtn__y1kyI`,
	"addBtn": `CustomFileUpload_addBtn__C4h1d`,
	"addbtnlight": `CustomFileUpload_addbtnlight__xYeiq`,
	"addbtndark": `CustomFileUpload_addbtndark__MeRsn`,
	"cust_addBtn": `CustomFileUpload_cust_addBtn__YT+wT`,
	"deleteBtn": `CustomFileUpload_deleteBtn__T26Lx`,
	"confirmBtn": `CustomFileUpload_confirmBtn__EAWmY`,
	"delPopContainer": `CustomFileUpload_delPopContainer__Cdqlz`,
	"modal-body": `CustomFileUpload_modal-body__FCE8h`,
	"delet_icon": `CustomFileUpload_delet_icon__yL4Cm`,
	"arrowback": `CustomFileUpload_arrowback__AFY42`,
	"drpdwn_btn": `CustomFileUpload_drpdwn_btn__hw5u8`,
	"empname": `CustomFileUpload_empname__QdOi2`,
	"navitemli": `CustomFileUpload_navitemli__OqcoP`,
	"tabnavli": `CustomFileUpload_tabnavli__dOKh3`,
	"settingsgeneral": `CustomFileUpload_settingsgeneral__1+PCY`,
	"settingslinks": `CustomFileUpload_settingslinks__xXnqV`,
	"dropdown_menu_contain": `CustomFileUpload_dropdown_menu_contain__01hrw`,
	"dropdown_item": `CustomFileUpload_dropdown_item__gQw5I`,
	"profile_arrrow_dwn": `CustomFileUpload_profile_arrrow_dwn__d1-N+`,
	"dateinputbox1": `CustomFileUpload_dateinputbox1__+Xw3U`,
	"messageminwidth": `CustomFileUpload_messageminwidth__dhX9z`,
	"sectionright": `CustomFileUpload_sectionright__2IKpO`,
	"exer_modal_contain": `CustomFileUpload_exer_modal_contain__0SRa7`,
	"modal-dialog": `CustomFileUpload_modal-dialog__bwGnn`,
	"upload_btn": `CustomFileUpload_upload_btn__6k0sh`,
	"uploaded_imgsection": `CustomFileUpload_uploaded_imgsection__-Sgt0`,
	"uploaded_img": `CustomFileUpload_uploaded_img__v2uMC`,
	"imgcancel_btn": `CustomFileUpload_imgcancel_btn__eh4bW`,
	"close_icon_main": `CustomFileUpload_close_icon_main__ZDd2K`,
	"close_icon": `CustomFileUpload_close_icon__M0Rfn`
};
export default ___CSS_LOADER_EXPORT___;
